var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReproductiveIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 104,
    viewBox: "0 0 6 104",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.1875L5.88675 0.1875L0.113249 0.1875L2.5 5.1875L3.5 5.1875ZM2.5 4.6875L2.50001 137.188L3.50001 137.187L3.5 4.6875L2.5 4.6875Z",
    fill: "#E99921"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReproductiveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reproductive_icon.6280954133a0768cf6ee032f25df0777.svg";